import { EditFilled } from "@ant-design/icons";
import { Button, Form, Input, message, Modal, Tooltip } from "antd";
import React, { useState, useEffect } from "react";
import HeaderTitle from "../../Components/HeaderTitle";
import { UpdateParameterMain } from "../../API/UpdateData";
import { AuthData, UpperCaseInput } from "../../Components/Global";

const EditParameter = ({ onData, onEdit }) => {

  const Auth = AuthData();
  const AccountId = Auth && Auth.AccountId;

  const [form] = Form.useForm();
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (isOpen && onData) {
      form.setFieldsValue(onData);
    }
  }, [form, isOpen, onData]);


  const showModal = () => {
    setIsOpen(true);
  };

  const handleSubmit = async (values) => {
    try {
      const payload = {
        ...values
      };
      const res = await UpdateParameterMain(AccountId, values.ParameterCode, payload);
      // console.log('Submit', res);
      if (res.status === 200) {
        message.success(res.data.message);
        setIsOpen(false);
        onEdit(true);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleReset = () => {
    form.resetFields();
    setIsOpen(false);
  };

  return (
    <>
      <Tooltip title="Edit">
        <Button icon={<EditFilled />} type="text" onClick={showModal} />
      </Tooltip>

      <Modal
        title={
          <HeaderTitle
            title="Parameter"
            subtitle="Edit data a Parameter"
          />
        }
        centered
        open={isOpen}
        closable={false}
        width={1000}
        styles={{
          body: {
            maxHeight: "70vh",
            overflow: "auto",
          },
        }}
        footer={false}
      >
        <Form
          name="basic"
          layout="vertical"
          onFinish={handleSubmit}
          autoComplete="off"
          form={form}
        >

          <Form.Item
            label="Parameter Code"
            name="ParameterCode"
            rules={[
              {
                required: true,
                message: 'Please input your Parameter Code!',
              },
            ]}
          >
            <Input placeholder="Parameter Code" disabled />
          </Form.Item>

          <Form.Item
            label="Parameter Name"
            name="ParameterName"
            rules={[
              {
                required: true,
                message: 'Please input your Parameter Name!',
              },
            ]}
          >
            <Input placeholder="Parameter Name" />
          </Form.Item>

          <Form.Item
            label="Parameter Number"
            name="ParameterNumber"
            rules={[
              {
                required: true,
                message: 'Please input your Parameter Number!',
              },
            ]}
          >
            <UpperCaseInput placeholder="Parameter Number" />
          </Form.Item>

          <div className="flex justify-end gap-2">
            <Button type="primary" htmlType="submit">Submit</Button>
            <Button htmlType="button" onClick={handleReset}>Cancel</Button>
          </div>

        </Form>
      </Modal>
    </>
  );
};

export default EditParameter;
